import BreadCrumb from "components/common/BreadCrumb";
import React from "react";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import { ContractsTable } from "./ContractsTable";
import { Link } from "react-router-dom";

import { getDocumentTitle } from "utils/helpers";
import { useAccess } from "features/Authentication/hooks/useAccess";
import { Permissions } from "features/RolesAndPermissions/constants/permission.constants";

const ContractList = () => {
  document.title = getDocumentTitle("Contracts");
  const { can } = useAccess();

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Contracts" pageTitle={`AMC Management`} />
          <Card>
            <CardHeader className="d-flex justify-content-between">
              <h5 className="card-title mb-0">Contract List</h5>
              {can(Permissions.AMC.CREATE) ? (
                <Link to={`/amc-management/create`} className="btn btn-primary">
                  <i className="ri-add-line align-bottom me-1"></i> Add Contract
                </Link>
              ) : null}
            </CardHeader>
            <CardBody>
              <ContractsTable />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ContractList;
